export default "__VITE_ASSET__caae3223__"